module.exports = __webpack_public_path__ + "media/win-up.e53fb4ba.mp3";